export const listTagNames = ['OL', 'UL']
